export default __webpack_public_path__ + "static/media/correct.e7ddf6cc.png";